'use strict';

var React = require('react');
require('react-dom');
var createReactClass = require('create-react-class');
var $ = require('jquery');
var _ = require('lodash');
var objectSearch = require('object-search');
var traverse = require('traverse');
var reactRedux = require('react-redux');
var redux = require('redux');
var client = require('react-dom/client');

var SelectroUtilities = {
  maxNodes: 1000,
  isIE() {
    let ua = window.navigator.userAgent;
    let msie = ua.indexOf("MSIE ");
    let trident = ua.indexOf("Trident/");
    let edge = ua.indexOf("Edge/");
    if (msie > -1 || trident > -1 || edge > -1) {
      return true;
    } else {
      return false;
    }
  },
  escapeRegExp(str) {
    return str.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
  },
  merge(a, b) {
    let start = Array.isArray(a) ? [] : {};
    let obj = $.extend(true, start, a);
    return $.extend(true, obj, b);
  },
  callback() {
    let args = [].slice.call(arguments);
    let cb = args.splice(0, 1)[0];
    if (cb) {
      if (typeof cb === "function") {
        return cb(args);
      } else {
        if (/\s/.test(cb)) {
          new Function(cb);
          return cb.apply(null, args);
        } else {
          // Check if cb has a ".", if so is a nested function that needs to be called.
          if (/\./.test(cb)) {
            let cbs = cb.split(".");
            let aggregate = window;
            cbs.forEach(c => aggregate = aggregate[c]);
            if (aggregate) {
              return aggregate.apply(null, args);
            }
          } else {
            return window[cb].apply(null, args);
          }
        }
      }
    }
  },
  isSearchShown(props, options) {
    if (!options) {
      ({
        options
      } = props);
    }
    if (typeof props.showSearch !== "undefined") {
      if (typeof props.showSearch === "boolean") {
        return props.showSearch;
      }
      if (typeof props.showSearch === "number") {
        return options.nodeLength >= parseInt(props.showSearch, 10);
      }
    } else if (props.multiple || props.collapsible || props.fetch || options.nodeLength >= 10) {
      return true;
    } else {
      return false;
    }
  }
};

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

var SelectroMeta = createReactClass({
  displayName: "SelectroMeta",
  render() {
    let meta;
    let css = ["selectro-option-text-prepend"];
    if (this.props.obj.hasOwnProperty("icon_class")) {
      css.push(this.props.obj.icon_class);
      css.push("selectro-option-icon");
      meta = /*#__PURE__*/React.createElement("i", {
        key: "icon_class",
        className: css.join(" "),
        title: this.props.obj.icon_title
      });
    }
    if (this.props.obj.hasOwnProperty("colored_box")) {
      css.push("selectro-colored-box");
      meta = /*#__PURE__*/React.createElement("span", {
        key: "colored_box",
        className: css.join(" "),
        style: {
          backgroundColor: this.props.obj.colored_box,
          borderColor: this.props.obj.border_color
        }
      });
    }
    return /*#__PURE__*/React.createElement("span", {
      style: {
        whiteSpace: "nowrap"
      }
    }, meta);
  }
});

var SelectroMatch = createReactClass({
  displayName: "SelectroMatch",
  render() {
    // Converting regex to string to test the "emptiness" of the search.
    // Testing both for initial emptiness and for emptiness after searching and deleting terms.
    let prepend, result;
    if (this.props.regex.toString() === "//" || this.props.regex.toString() === "/(?:)/" || this.props.regex.toString() === "/(?:)/gi") {
      result = this.props.text && this.props.text.length > 0 ? this.props.text : "\u00a0"; // = &nbsp;
    } else {
      let parts = this.props.text.split(this.props.regex);
      result = [];
      let start = 0;
      let originalText = this.props.text;
      let {
        queryLength
      } = this.props;
      if (parts) {
        parts.forEach((part, i) => {
          result.push(part);
          start += part.length;
          if (i < parts.length - 1) {
            let end = start + queryLength;
            result.push(/*#__PURE__*/React.createElement("span", {
              key: part + i + "match",
              className: "selectro-match"
            }, originalText.slice(start, end)));
            return start += this.props.queryLength;
          }
        });
      } else {
        result.push(text);
      }
    }
    if (this.props.meta && this.props.meta.prepend) {
      prepend = [];
      this.props.meta.prepend.forEach(obj => prepend = /*#__PURE__*/React.createElement(SelectroMeta, {
        obj: obj
      }));
    }
    return /*#__PURE__*/React.createElement("span", {
      className: "selectro-option-text"
    }, prepend, result);
  }
});

// Persist changes made in the selectro popup menu back to the selectro trigger element
// (which, for pre-portal reasons exists outside the component).
function persistSelectionToTrigger(changes, props) {
  // If selected value is the same as before, don't do anything (prevents reactive updates from being called).
  if (JSON.stringify(props.value) !== JSON.stringify(changes)) {
    updateRemote(changes.map(x => x.value), props);
    updateTrigger(changes, props);
  }
}
function persistAutoupdateToTrigger(previouslySelected, autoUpdateSelected, props) {
  if (JSON.stringify(previouslySelected.sort()) !== JSON.stringify(autoUpdateSelected.sort())) {
    updateTriggerAutoupdateSubmenu(autoUpdateSelected, props);
  }
}
function updateRemote(values, props) {
  if (props.update) {
    let method;
    let data = {
      authenticity_token: document.querySelector('meta[name="csrf-token"]').content
    };
    if (props.update_method) {
      method = props.update_method;
    } else {
      method = "POST";
      data["_method"] = "put";
    }
    data[props.name] = props.multiple ? values : values.toString();
    return $.ajax({
      url: props.update,
      method,
      data
    });
  }
}
function updateTrigger(selected, props) {
  return props.element.selectroValue = selected.map(opt => [opt.text, opt.value]);
}
function updateTriggerAutoupdateSubmenu(values, props) {
  // This data-submenu_autoupdate attribute is only used when a selectro is
  // created with the selectro_tag helper. When the Selectro React component is
  // used directly, the attribute will not be present.
  if (!props.element.dataset.submenu_autoupdate) {
    return;
  }
  const data = JSON.parse(props.element.dataset.submenu_autoupdate);
  data.selections = values;
  props.element.dataset.submenu_autoupdate = JSON.stringify(data);
}
function autoUpdateInParents(node, submenu) {
  if (!submenu) return false;
  const {
    selections = []
  } = submenu;
  const parentIds = node.parents().map(p => p.value);
  return selections.some(v => parentIds.includes(v));
}
function isSearching(props) {
  const string = props.regex.toString();
  return string !== "/(?:)/" && string !== "/(?:)/gi" && string !== "//" && string !== "//gi";
}

var SelectroCollapseArrow = createReactClass({
  displayName: "SelectroCollapseArrow",
  toggleOpenState(node) {
    let openState;
    let {
      collapseState
    } = this.props;
    if (collapseState.hasOwnProperty(node.value)) {
      openState = !collapseState[node.value];
    } else {
      openState = node.containsSelected() ? false : true;
    }
    collapseState[node.value] = openState;
    return this.props.store.dispatch({
      type: "TOGGLE_ARROW",
      payload: collapseState,
      uuid: this.props.uuid
    });
  },
  setHover(index) {
    return this.props.store.dispatch({
      type: "SET_HOVERED",
      hoveredIndex: index,
      hoveredSetVia: "pointer"
    });
  },
  render() {
    let handleClick;
    let hasSearchTerm = isSearching(this.props);
    let css = "selectro-collapse-arrow";
    if (hasSearchTerm) {
      css += " is-hidden";
    } else {
      let openState;
      if (this.props.collapseState.hasOwnProperty(this.props.node.value)) {
        openState = this.props.collapseState[this.props.node.value];
      } else if (this.props.node.containsSelected()) {
        openState = true;
      } else {
        openState = false;
      }
      css += openState ? " is-open" : " is-closed";
      handleClick = e => {
        e.preventDefault();
        e.stopPropagation();
        return this.toggleOpenState(this.props.node);
      };
    }
    return /*#__PURE__*/React.createElement("span", {
      className: css,
      onClick: handleClick,
      onMouseEnter: () => this.setHover(this.props.i)
    }, /*#__PURE__*/React.createElement("svg", {
      width: "12px",
      height: "12px",
      viewBox: "0 0 12 12",
      version: "1.1",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("g", {
      className: "svg-arrow-group",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("rect", {
      className: "svg-rectangle",
      x: "0",
      y: "0",
      width: "12",
      height: "12"
    }), /*#__PURE__*/React.createElement("polygon", {
      className: "svg-triangle",
      fill: "#555555",
      transform: "translate(6.245283, 6.000000) rotate(90.000000) translate(-6.245283, -6.000000) ",
      points: "6.24528302 2.75471698 10.245283 9.24528302 2.24528302 9.24528302"
    }))));
  }
});

// Set redux state and also propagate those changes back to the selectro trigger.
function selectAction(payload, option, props, callback) {
  const previousSelected = props.value || [];
  const isSelected = props.value.some(prev => prev.value === option.value);
  // const changes = calculateChanges(option, props);

  props.store.dispatch({
    type: "SET_SELECTED",
    payload
  });
  persistSelectionToTrigger(payload.value, props);
  SelectroUtilities.callback(props.selectedCallback, {
    option: option,
    currentState: props.store.getState(),
    previousSelected,
    action: isSelected ? "removed" : "added"
  });
}
function clearSomeAction(payload, props) {
  const previousSelected = props.value || [];
  props.store.dispatch({
    type: "SET_SELECTED",
    payload
  });
  persistSelectionToTrigger(payload.value, props);
  SelectroUtilities.callback(props.selectedCallback, {
    option: null,
    currentState: props.store.getState(),
    previousSelected,
    action: "removed"
  });
}
function selectAutoupdateAction(option, state, props) {
  const autoUpdatePreviouslySelected = state.submenuAutoupdate && state.submenuAutoupdate.selections || [];
  const autoUpdateSelected = autoUpdatePreviouslySelected.slice();
  const willAutoUpdate = !autoUpdatePreviouslySelected.includes(option.value);
  const previouslySelectedOptions = state.value || [];

  // Determine the updated values that will be stored in the "auto update" ids.
  const index = autoUpdateSelected.indexOf(option.value);
  if (index > -1) {
    autoUpdateSelected.splice(index, 1);
  } else {
    autoUpdateSelected.push(option.value);
  }

  // Determine the updated child values that will be stored in the "selected" ids.
  const selectedOptions = previouslySelectedOptions.slice();

  // Select all visible descendants (disabled for now, may need to add back later).
  option.descendants().forEach(desc => {
    const index = selectedOptions.findIndex(selOpt => selOpt.value === desc.value);
    if (!willAutoUpdate && index > -1) {
      selectedOptions.splice(index, 1);
    } else if (willAutoUpdate && index === -1) {
      selectedOptions.push(desc);
    }
  });

  // The selected state of the parent element needs to be determined separately.
  const parentIndex = selectedOptions.findIndex(selOpt => selOpt.value === option.value);
  if (parentIndex > -1) {
    if (!willAutoUpdate) {
      selectedOptions.splice(parentIndex, 1);
    }
  } else {
    if (willAutoUpdate) {
      selectedOptions.push(option);
    }
  }
  state.store.dispatch({
    type: "SET_AUTOUPDATE",
    option,
    selectedOptions,
    autoUpdateSelected
  });
  persistAutoupdateToTrigger(autoUpdatePreviouslySelected, autoUpdateSelected, props); // TODO:
  persistSelectionToTrigger(selectedOptions, props);
  if (state.submenuAutoupdate && state.submenuAutoupdate.callback) {
    SelectroUtilities.callback(state.submenuAutoupdate.callback, {
      option: option,
      currentState: state.store.getState(),
      selectedOptions,
      previouslySelectedOptions,
      autoUpdateSelected,
      autoUpdatePreviouslySelected,
      action: willAutoUpdate ? "added" : "removed"
    });
  }
}

const padding = 30;
class SubMenu extends React.Component {
  constructor(props) {
    super(props);
    this.preventKeyDown = event => event.stopPropagation();
    this.focusedElement = undefined;
    this.handleSelectAllChildren = this.handleSelectAllChildren.bind(this);
    this.handleSelectImmediateChildren = this.handleSelectImmediateChildren.bind(this);
    this.handleAutoUpdate = this.handleAutoUpdate.bind(this);
    this.submenu = /*#__PURE__*/React.createRef();
  }
  handleClick(event) {
    event.stopPropagation();
    event.preventDefault();
  }
  handleSelectAllChildren() {
    this.props.doSelect(_.flattenDeep([this.props.node, this.props.node.descendants()]));
  }
  handleSelectImmediateChildren() {
    this.props.doSelect(this.props.node.children); //, this.props);
  }
  handleAutoUpdate() {
    this.props.doAutoUpdate(this.props.node);
  }
  setPosition() {
    const {
      top: triggerTop,
      bottom: triggerBottom,
      left: triggerLeft,
      right: triggerRight,
      width: triggerWidth,
      height: triggerHeight
    } = this.props.triggerPosition;
    let left, right, top, bottom, width, maxHeight;
    const buttonMidX = triggerLeft + triggerWidth / 2;
    const windowMidX = window.innerWidth / 2;
    const windowMidY = window.innerHeight / 2;
    if (buttonMidX < windowMidX) {
      left = triggerLeft;
      right = undefined;
      width = window.innerWidth - triggerLeft - padding;
    } else {
      left = undefined;
      right = window.innerWidth - triggerRight;
      width = triggerRight - padding;
    }
    if (triggerBottom < windowMidY) {
      top = triggerBottom;
      bottom = undefined;
      maxHeight = window.innerHeight - triggerBottom - padding;
    } else {
      top = undefined;
      bottom = window.innerHeight - triggerTop;
      maxHeight = triggerTop - padding;
    }
    return {
      top,
      bottom,
      left,
      right,
      width,
      maxHeight
    };
  }
  componentDidMount() {
    document.addEventListener("keydown", this.preventKeyDown, true);
    this.repaintIE();
  }
  componentWillUnmount() {
    document.removeEventListener("keydown", this.preventKeyDown, true);
  }

  // Force IE11 to repaint the submenu, which will force it to be displayed.
  // Otherwise IE11 will only show the submenu when the user mouses over the element,
  // triggering the repaint as hover styles are applied.
  // Why? Because IE11 is garbage, why else?
  repaintIE() {
    if (SelectroUtilities.isIE()) {
      const styles = getComputedStyle(this.submenu.current);
      requestAnimationFrame(() => {
        this.submenu.current.style.backgroundColor = styles.backgroundColor;
      });
    }
  }
  render() {
    const {
      selectedIds,
      someChildrenSelected,
      allChildrenSelected,
      allImmediateChildrenSelected,
      autoUpdateSelected,
      node,
      handleClearAll,
      submenuChildren,
      submenuAutoupdate,
      query
    } = this.props;
    return /*#__PURE__*/React.createElement("div", {
      className: "selectro__sub-select-menu",
      style: this.setPosition(),
      onClick: this.handleClick,
      ref: this.submenu
    }, submenuChildren && /*#__PURE__*/React.createElement("ul", null, !allChildrenSelected && !autoUpdateSelected && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      onClick: this.handleSelectAllChildren
    }, "Select all")), node.children.length !== node.descendants().length && !allImmediateChildrenSelected && !autoUpdateSelected && /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      onClick: this.handleSelectImmediateChildren
    }, "Select immediate children only")), /*#__PURE__*/React.createElement("li", {
      disabled: !someChildrenSelected && selectedIds.indexOf(node.value) === -1 || autoUpdateSelected
    }, /*#__PURE__*/React.createElement("a", {
      onClick: handleClearAll
    }, "Clear selection"))), submenuAutoupdate && /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("a", {
      className: "selectro__sub-select-auto-update",
      onClick: this.handleAutoUpdate
    }, /*#__PURE__*/React.createElement("span", {
      className: ["selectro__checkbox", autoUpdateSelected ? "selectro__checkbox--checked" : ""].join(" ")
    }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
      className: "fa-solid fa-rotate"
    }), submenuAutoupdate.text && submenuAutoupdate.text.autoupdate || "Auto-update to include any new items added in the future.")))));
  }
}
const mapStateToProps = (state, ownProps) => {
  const selectedIds = state.value.map(opt => opt.value);
  const allChildIds = ownProps.node.descendants().map(opt => opt.value);
  const someChildrenSelected = allChildIds.some(childId => selectedIds.includes(childId));
  const allImmediateChildrenSelected = ownProps.node.children.every(child => selectedIds.includes(child.value));
  const selections = state.submenuAutoupdate && state.submenuAutoupdate.selections || [];
  const autoUpdateSelected = selections.includes(ownProps.node.value);
  return {
    selectedIds,
    someChildrenSelected,
    allChildrenSelected: someChildrenSelected && allChildIds.every(childId => selectedIds.includes(childId)),
    allImmediateChildrenSelected,
    autoUpdateSelected
  };
};
const mapDispatchToProps = (dispatch, ownProps) => ({
  doSelect: changes => {
    const {
      hoveredIndex,
      hoveredSetVia,
      value
    } = ownProps;
    const currentValues = value.map(opt => opt.value);
    const selected = changes.reduce((acc, opt) => {
      if (!currentValues.includes(opt.value)) {
        acc.push(opt);
      }
      return acc;
    }, value.slice());
    const payload = {
      value: selected,
      hoveredIndex,
      hoveredSetVia
    };
    selectAction(payload, selected, ownProps);
    ownProps.closeSubmenu();
  },
  handleClearAll: () => {
    const {
      hoveredIndex,
      hoveredSetVia,
      node,
      value
    } = ownProps;
    const descendants = _.flattenDeep([node, node.descendants()]);
    if (descendants.length === 0) return;
    const descendantValues = descendants.map(descendant => descendant.value);
    const selected = value.filter(opt => !descendantValues.includes(opt.value));
    const payload = {
      value: selected,
      hoveredIndex,
      hoveredSetVia
    };
    clearSomeAction(payload, ownProps);
    ownProps.closeSubmenu();
  },
  doAutoUpdate: node => {
    selectAutoupdateAction(node, ownProps.store.getState(), ownProps);
    ownProps.closeSubmenu();
  }
});
var SubMenu$1 = reactRedux.connect(mapStateToProps, mapDispatchToProps)(SubMenu);

class SubMenuTrigger extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      triggerPosition: undefined
    };
    this.handleClick = this.handleClick.bind(this);
    this.closeSubmenu = this.closeSubmenu.bind(this);
  }
  handleClick(event) {
    event.stopPropagation();
    this.setState({
      isOpen: !this.state.isOpen,
      triggerPosition: event.currentTarget.getBoundingClientRect()
    });
  }
  closeSubmenu() {
    this.setState({
      isOpen: false
    });
  }
  render() {
    const {
      multiple: {
        type
      },
      submenuChildren,
      submenuAutoupdate
    } = this.props.store.getState();
    const {
      isOpen
    } = this.state;
    if (type.includes("independent") && (submenuChildren || submenuAutoupdate) && !autoUpdateInParents(this.props.node, submenuAutoupdate)) {
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "selectro__sub-select",
        onClick: this.handleClick
      }, submenuAutoupdate && submenuAutoupdate.selections.includes(this.props.node.value) && /*#__PURE__*/React.createElement("i", {
        className: "fa-solid fa-rotate",
        style: {
          marginRight: "1ch"
        },
        "data-tooltip": true,
        "data-container": ".selectro-modal",
        "data-title-ref": true,
        "data-content": submenuAutoupdate.text && submenuAutoupdate.text.parent || "Includes any added future items.",
        "data-class": "aha-tooltip--align-left"
      }, /*#__PURE__*/React.createElement("script", {
        type: "text/template"
      }, /*#__PURE__*/React.createElement("b", null, /*#__PURE__*/React.createElement("i", {
        className: "fa-solid fa-rotate"
      }), " Auto-update enabled"))), /*#__PURE__*/React.createElement("i", {
        className: "fa-solid fa-caret-down"
      })), isOpen && /*#__PURE__*/React.createElement("div", {
        className: "selectro__sub-select-overlay",
        onClick: this.handleClick
      }), isOpen && /*#__PURE__*/React.createElement(SubMenu$1, _extends({
        triggerPosition: this.state.triggerPosition,
        closeSubmenu: this.closeSubmenu
      }, this.props)));
    } else {
      return null;
    }
  }
}

let nodeIsPresentInCollapsedList = function (collapsedList, node, regex) {
  if (typeof collapsedList === 'undefined' || typeof regex !== 'undefined') {
    return true;
  } else {
    let parentIds = node.parents().map(x => x.value);
    return parentIds.every(id => collapsedList[id] !== false);
  }
};
function hasOrBelongsToHideSubmenu(node) {
  return node.meta && node.meta.hide_submenu || node.parents().some(p => p.meta && p.meta.hide_submenu);
}
function selfAndChildNodes(node, accumulator = [node]) {
  if (!node || !node.children) return [];
  return node.children.reduce((acc, child) => {
    acc.push(child);
    selfAndChildNodes(child, acc);
    return acc;
  }, accumulator);
}
function descendants(node) {
  return selfAndChildNodes(node, []);
}
var SelectroTree = {
  getRecentOptions(options, uuid, args) {
    // If we are using ajax for the options then this will be an empty array
    if (!options.children) {
      return;
    }
    let recentOptionsOffset = args.recentOptionsOffset || 0;
    let selectroStorage = localStorage.getItem('selectro-recent');
    let recent = selectroStorage ? JSON.parse(selectroStorage)[uuid] : [];
    if (!recent) {
      recent = [];
    }
    let recentOptions = [];
    let nodes = traverse(options.children).nodes().filter(node => node.hasOwnProperty('value'));

    // Used by project switcher - if someone has a nested team and the same team non-nested
    // in their recent options, we should only include one of the copies.
    //
    // Additionally, we prefer using the non-nested node for consistent styling.
    if (args.ignoreNestedRecents) {
      // Nested node values look like grandparentId/parentId/projectId -
      // we split by `/` to get the non-nested value.
      recent = [...new Set(recent.map(value => value.split('/').at(-1)))];
    }
    recent = recent.slice(recentOptionsOffset);
    recent.forEach(function (recentValue) {
      let match = nodes.filter(node => node.value === recentValue)[0];
      if (match) {
        return recentOptions.push({
          text: match.text,
          value: match.value,
          meta: match.meta
        });
      }
    });
    const tree = this.create({
      children: recentOptions
    }, args);
    return tree;
  },
  create(tree, args) {
    let collapsedList, headersClickable;
    if (args == null) {
      args = {};
    }
    let {
      regex
    } = args;
    let {
      filterSearch
    } = args;
    if (!args.selected) {
      args.selected = [];
    }
    if (!args.firstSelected) {
      args.firstSelected = _.uniq(args.selected)[0];
    }
    if (args.props.multiple) {
      headersClickable = typeof args.headersClickable === 'undefined' ? true : args.headersClickable;
    } else {
      headersClickable = typeof args.headersClickable === 'undefined' ? false : args.headersClickable;
    }
    ({
      headersClickable
    } = args);
    let {
      hoveredIndex
    } = args;
    let selectedNodes = [];
    // flatList = []

    //# Read a sessionStorage variable to get the saved collapsed state.
    if (args.props.collapsible && typeof args.props.uuid !== 'undefined') {
      let collapsedStorage = sessionStorage.getItem('selectro-collapsible');
      collapsedStorage = collapsedStorage ? JSON.parse(collapsedStorage) : {};
      collapsedList = collapsedStorage[args.props.uuid] || {};
    }
    let traversedTree = traverse(tree);

    // Append useful info to each node of the tree.
    let counter = 0;
    let selectedValues = args.selected.map(opt => opt.value);
    traversedTree.forEach(function (node) {
      if (this.key === 'nodeLength') return;
      if (node && node.hasOwnProperty('value')) {
        // flatList.push({text: node.text, value: node.value, level: this.level/2 - 1})
        if (selectedValues.indexOf(node.value) > -1) {
          selectedNodes.push(node);
          if (typeof hoveredIndex === 'undefined' && args.firstSelected.hasOwnProperty('value') && node.value === args.firstSelected.value) {
            traversedTree.value.hoveredIndex = counter + (args.offset || (args.offset = 0));
          }
        }
        if (node.hasOwnProperty('children')) {
          if (headersClickable) {
            counter++;
          }
        } else {
          counter++;
        }
      }

      // Put HTML directly into the tree. We're looping over it anyway, may as well kill 2 birds with 1 stone.
      //# ROOT ELEMENT
      if (this.isRoot) {
        node.isGroup = true;
        node.isLeaf = false;
        node.react = function () {
          args = arguments[0] || {};
          if (!args.key) {
            args.key = '';
          }
          if (!args.className) {
            args.className = '';
          }
          if (!args.value) {
            args.value = this.props.value;
          }
          args.hoveredIndex = this.props.hoveredIndex;
          this.listType = args.listType;
          let children = [];
          if (this.listType === 'selected') {
            if (!this.listCleared) {
              children = _.compact(node.children).map(child => {
                return child.react.bind(this, args)();
              });
              if (children.filter(opt => typeof opt !== 'undefined').length > 0) {
                children.splice(0, 0, /*#__PURE__*/React.createElement("li", {
                  className: "selectro-list-clear",
                  key: "clear"
                }, /*#__PURE__*/React.createElement("a", {
                  key: "multi-clear",
                  onClick: this.handleClear
                }, "Clear selected items")));
              }
            }
          } else {
            children = _.compact(node.children).map(child => {
              return child.react.bind(this, args)();
            });
          }
          if (this.props.fetching) {
            args.className += ' selectro-list-is-loading';
          }
          return /*#__PURE__*/React.createElement("ul", {
            className: [args.className].join(' '),
            "data-empty-text": "No results",
            "data-fetching-text": "Loading \u2026",
            "data-label": args.label
          }, children);
        };
        node.curryNode = function () {
          return _.compact(_.flatten(_.compact(node.children).map(child => child.curryNode.bind(null, args)())));
        };
        node.curryLeaf = function () {
          return _.compact(_.flatten(_.compact(node.children).map(child => child.curryLeaf.bind(null, args)())));
        };
        node.descendants = descendants.bind(null, node);
        Object.defineProperty(node, 'nodeLength', {
          enumerable: true,
          get() {
            return _.compact(node.children).map(child => child.nodeLength).reduce((prev, current) => prev + current, 0);
          }
        });
        Object.defineProperty(node, 'leafLength', {
          enumerable: true,
          get() {
            return _.compact(node.children).map(child => child.leafLength).reduce((prev, current) => prev + current, 0);
          },
          set() {
            return;
          }
        });

        //# BRANCH ELEMENT
      } else if (node && node.hasOwnProperty('children')) {
        node.isGroup = true;
        node.isLeaf = false;
        node.path = this.path;
        node.react = function () {
          args = arguments[0] || {};
          if (!args.key) {
            args.key = '';
          }
          let className = ['selectro-list-header'];

          // selectedValues can be either "values that were cached when opened" or "live values", depending on if it we are rendering the "selected list" or the "standard list".
          // currentSelectedValues, meanwhile, always refer to the values of what is *currently* selected.
          selectedValues = this.listType === 'selected' ? this.cachedSelectedValues : args.value.map(opt => opt.value);
          let currentSelectedValues = args.value.map(opt => opt.value);
          if (!args.hideUnselected || node.curryNode().some(y => selectedValues.indexOf(y.value) > -1)) {
            var _node$meta;
            // Switches on/off the ability of the group header to be hovered/selected
            let collapseArrow, divider, headerClickAction, headerMouseOver, hoveredOpt, i;
            if (headersClickable) {
              if (!nodeIsPresentInCollapsedList(collapsedList, node, regex)) {
                return;
              }
              i = counter = this.autoCounter();
              headerClickAction = this.handleMouseDown.bind(this, node);
              headerMouseOver = this.handleMouseEnter.bind(this, i);
              if (args.hoveredIndex === i) {
                className.push('is-hovered');
                hoveredOpt = selfElem => {
                  return this.hoveredOpt = selfElem;
                };
                this.hoveredNode = node;
              }

              //# TREE
              if (this.props.multiple && this.props.multiple.hasOwnProperty('type') && this.props.multiple.type.indexOf('tree') > -1) {
                // If *all* children are selected, or if the group value itself is selected, then the group is selected.
                let curriedLeafValues = node.curryLeaf().map(opt => opt.value);
                if (curriedLeafValues.every(y => currentSelectedValues.indexOf(y) > -1) || currentSelectedValues.indexOf(node.value) > -1) {
                  className.push('is-selected');

                  // If *some* children are selected, then the group is in the "indeterminate" state.
                } else if (curriedLeafValues.some(y => currentSelectedValues.indexOf(y) > -1)) {
                  className.push('some-selected');
                }

                //# INDEPENDENT, BOUND CHILD, BOUND PARENT
              } else if (currentSelectedValues.indexOf(node.value) > -1) {
                className.push('is-selected');
              }
            } else {
              i = node.value;
              if (!nodeIsPresentInCollapsedList(collapsedList, node, regex)) {
                return;
              }
              counter = this.autoCounter(false);
              if (headersClickable) {
                headerClickAction = this.handleMouseDown.bind(this, node);
                headerMouseOver = this.handleMouseEnter.bind(this, i);
                if (args.hoveredIndex === i) {
                  className.push('is-hovered');
                  hoveredOpt = 'hoveredOpt';
                  this.hoveredNode = node;
                }
              } else {
                headerClickAction = null;
                headerMouseOver = null;
              }
            }
            let nodeCurryValues = node.curryNode().map(opt => opt != null ? opt.value : undefined);
            let isSelectedCache = this.cachedSelectedValues.some(function (cachedSelectedValue) {
              if (nodeCurryValues.indexOf(cachedSelectedValue) > -1) {
                return true;
              }
            });
            let liClassName = [];
            if (isSelectedCache) {
              liClassName.push('in-selected-cache');
            }
            if (this.props.collapsible && this.props.uuid) {
              collapseArrow = /*#__PURE__*/React.createElement(SelectroCollapseArrow, {
                store: this.props.store,
                collapseState: collapsedList || {},
                node: node,
                i: i,
                regex: this.props.regex,
                uuid: this.props.uuid
              });
            }
            if (node.meta) {
              if (node.meta.css_class) {
                className.push(`${node.meta.css_class}`);
              }
              if (node.meta.divider) {
                className.push('selectro-list-divider');
                divider = /*#__PURE__*/React.createElement("div", {
                  className: "selectro-list-divider"
                });
              }
            }
            if (this.props.headersClickable) {
              className.push('selectro-option');
            }
            let queryLength = this.props.query ? this.props.query.length : 0;
            if (counter >= SelectroUtilities.maxNodes) {
              return;
            }
            let tooltip, title;
            if (this.props.submenuAutoupdate && !hasOrBelongsToHideSubmenu(node)) {
              const state = this.props.store.getState();
              if (autoUpdateInParents(node, state.submenuAutoupdate)) {
                className.push('selectro-disabled-option is-selected');
                tooltip = true;
                title = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
                  className: "fa-solid fa-rotate"
                }), ' ', this.props.submenuAutoupdate.text && this.props.submenuAutoupdate.text.child || 'To unselect any item you must first disable auto-update.');
                headerClickAction = null;
              }
            }
            const forceDescendants = this.props.selectingForcesDescendants && selectedValues.includes(node.value);
            return /*#__PURE__*/React.createElement("li", {
              key: i + args.key,
              className: liClassName.join(' ')
            }, divider, collapseArrow, /*#__PURE__*/React.createElement("header", {
              "aria-selected": className.includes('is-selected') ? 'true' : 'false',
              "data-i": i,
              className: className.join(' '),
              ref: hoveredOpt,
              onMouseMove: headerMouseOver,
              onClick: headerClickAction,
              "data-value": node.value,
              "data-tooltip": tooltip,
              "data-title-ref": ".title",
              "data-placement": ((_node$meta = node.meta) === null || _node$meta === void 0 ? void 0 : _node$meta.tooltip_location) || 'left',
              "data-container": ".selectro-modal",
              "data-class": "aha-tooltip--align-left"
            }, tooltip && /*#__PURE__*/React.createElement("script", {
              type: "text/javascript",
              className: "title"
            }, title), /*#__PURE__*/React.createElement(SelectroMatch, {
              regex: this.props.regex,
              text: node.text,
              queryLength: queryLength,
              meta: node.meta
            }), this.props.multiple && !hasOrBelongsToHideSubmenu(node) && /*#__PURE__*/React.createElement(SubMenuTrigger, _extends({}, this.props, {
              node: node
            }))), /*#__PURE__*/React.createElement("ul", {
              className: forceDescendants ? 'selectro-force-descendants' : ''
            }, _.compact(node.children).map(child => child.react.bind(this, args)())));
          }
        };
        node.curryNode = function () {
          let children = _.compact(_.flatten(_.compact(node.children).map(child => child.curryNode.bind(null, args)())));
          return [node].concat(children);
        };
        node.curryLeaf = function () {
          return _.compact(_.flatten(_.compact(node.children).map(child => child.curryLeaf.bind(null, args)())));
        };
        node.descendants = descendants.bind(null, node);
        node.parents = (parents => parents).bind(null, this.parents.filter(parent => !parent.isRoot && parent.node.isGroup).map(parent => parent.node));
        Object.defineProperty(node, 'nodeLength', {
          enumerable: true,
          get() {
            return 1 + _.compact(node.children).map(child => child.nodeLength).reduce((prev, current) => prev + current, 0);
          }
        });
        Object.defineProperty(node, 'leafLength', {
          enumerable: true,
          get() {
            return _.compact(node.children).map(child => child.leafLength).reduce((prev, current) => prev + current, 0);
          },
          set() {
            return;
          }
        });
        node.containsSelected = () => node.curryNode().map(opt => opt.value).some(v => selectedValues.indexOf(v) > -1);

        //# LEAF ELEMENT
      } else if (node && node.hasOwnProperty('text')) {
        node.isGroup = false;
        node.isLeaf = true;
        node.react = function () {
          args = arguments[0] || {};
          if (!args.key) {
            args.key = '';
          }

          // selectedValues can be either "values that were cached when opened" or "live values", depending on if it we are rendering the "selected list" or the "standard list".
          // currentSelectedValues, meanwhile, always refer to the values of what is *currently* selected.
          selectedValues = this.listType === 'selected' ? this.cachedSelectedValues : args.value.map(opt => opt.value);
          let currentSelectedValues = args.value.map(opt => opt.value);
          if (!args.hideUnselected || selectedValues.indexOf(node.value) > -1) {
            var _node$meta2;
            let tooltip, divider, hoveredOpt, title;
            if (!nodeIsPresentInCollapsedList(collapsedList, node, regex)) {
              return;
            }
            let i = this.autoCounter();
            if (i >= SelectroUtilities.maxNodes) {
              return;
            }
            let optionClickAction = this.handleMouseDown.bind(this, node);
            let className = 'selectro-option';
            if (args.hoveredIndex === i) {
              className += ' is-hovered';
              hoveredOpt = selfElem => {
                return this.hoveredOpt = selfElem;
              };
              this.hoveredNode = node;
            }
            if (currentSelectedValues.indexOf(node.value) > -1) {
              className += ' is-selected';
            }

            // if @cachedSelectedValues.indexOf(node.value) > -1
            //   className += ' in-selected-cache'

            if (node.meta) {
              if (node.meta.css_class) {
                className += ` ${node.meta.css_class}`;
              }
              if (node.meta.divider) {
                divider = /*#__PURE__*/React.createElement("div", {
                  className: "selectro-list-divider"
                });
                className += ' selectro-list-divider';
              }
              if (node.meta.disabled) {
                className += ' selectro-disabled-option';
                tooltip = true;
                title = node.meta.disabled_message;
              }
            }
            if (this.props.submenuAutoupdate && !hasOrBelongsToHideSubmenu(node)) {
              const state = this.props.store.getState();
              if (autoUpdateInParents(node, state.submenuAutoupdate)) {
                className += ' selectro-disabled-option is-selected';
                tooltip = true;
                title = /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("i", {
                  className: "fa-solid fa-rotate"
                }), ' ', this.props.submenuAutoupdate.text && this.props.submenuAutoupdate.text.child || 'To unselect any item you must first disable auto-update.');
                optionClickAction = null;
              }
            }
            let queryLength = this.props.query ? this.props.query.length : 0;
            return /*#__PURE__*/React.createElement("li", {
              "aria-selected": className.includes('is-selected') ? 'true' : 'false',
              key: i + args.key,
              "data-i": i,
              className: className,
              ref: hoveredOpt,
              onClick: optionClickAction,
              onMouseMove: this.handleMouseEnter.bind(this, i),
              "data-value": node.value,
              "data-tooltip": tooltip,
              "data-title-ref": ".title",
              "data-container": ".selectro-modal",
              "data-placement": ((_node$meta2 = node.meta) === null || _node$meta2 === void 0 ? void 0 : _node$meta2.tooltip_location) || 'left',
              "data-class": "aha-tooltip--align-left"
            }, tooltip && /*#__PURE__*/React.createElement("script", {
              type: "text/javascript",
              className: "title"
            }, title), divider, /*#__PURE__*/React.createElement(SelectroMatch, {
              regex: this.props.regex,
              text: node.text,
              queryLength: queryLength,
              meta: node.meta
            }));
          }
        };
        node.curryNode = () => [node];
        node.curryLeaf = () => [node];
        node.descendants = descendants.bind(null, node);
        node.parents = (parents => parents).bind(null, this.parents.filter(parent => !parent.isRoot && parent.node.isGroup).map(parent => parent.node));
        Object.defineProperty(node, 'nodeLength', {
          enumerable: true,
          get() {
            return 1;
          }
        });
        Object.defineProperty(node, 'leafLength', {
          enumerable: true,
          get() {
            return 1;
          },
          set() {
            return;
          }
        });
      }
      return node;
    });

    // traversedTree.value.flatList = flatList
    traversedTree.value.initialHoveredOffset = function () {
      // window.SelectroTree.getRecentOptions(nodes, @props.uuid, {regex: @props.regex, headersClickable: @props.headersClickable, recentOptionsOffset: @props.recentOptionsOffset})
      // debugger
      // console.warn "Need to track how many 'recent nodes' there are that are matched to existing options"
      if (!args.props.multiple) {
        return 0;
      } else {
        let nodes = [];
        selectedNodes.forEach(function (node) {
          nodes.push(node.value);
          if (headersClickable) {
            return node.parents().forEach(parent => nodes.push(parent.value));
          }
        });
        return _.uniq(nodes).length;
      }
    };

    // debugger
    // if typeof filterSearch == 'undefined'
    //   traversedTree.value.filterSearch = traversedTree.value.nodeLength >= 10
    // else
    //   traversedTree.value.filterSearch = filterSearch

    //# Searching and filtering.
    if (regex) {
      if (filterSearch) {
        let removeNodes = [];
        // FILTERED SEARCH
        traversedTree.map(function (x) {
          regex.lastIndex = 0;
          if (x && this.notRoot) {
            if (x.hasOwnProperty('text')) {
              regex.lastIndex = 0;
              if (regex.test(x.text)) {
                return x;
              } else if (regex.test(x.curryNode().map(opt => opt.text).join())) {
                return x;
              } else if (!args.props.searchExcludeChildren) {
                let parentText = this.parents.map(parent => parent.node.text).join();
                if (regex.test(parentText)) {
                  return x;
                }
              }

              // NOTE: while it would be great if we could just remove the node completely (via .remove(true)), doing so causes
              // js-traverse to lose its place in the .map/.forEach loop, giving us bizarro results.
              // To fix this, we just capture the path to delete, and remove it once the loop is complete
              removeNodes.push(this.path);
              // While technically we don't need to delete the node, doing so prevents js-traverse from walking any nested nodes.
              this.delete(true);
              return;
            }
          }
        });

        // Remove nodes that have been filtered out via searching. Do it here (rather than as we walk the tree) to prevent a bug in js-traverse.
        if (removeNodes) {
          removeNodes.map(path =>
          // console.log 'PATH', path.join('.'), objectSearch.get(traversedTree.value, path.join('.')).text
          objectSearch.del(traversedTree.value, path.join('.')));
        }
      }
    }
    return traversedTree.value;
  }
};

// restrict-scroll exports in a weird way
const restrictScroll = require('restrict-scroll').default;
var SelectroPopup = createReactClass({
  displayName: "SelectroPopup",
  noSearchTimer: null,
  debounceTimer: null,
  filteredOptionCounter: null,
  optionCounter: 0,
  keys: {
    down: 40,
    up: 38,
    escape: 27,
    enter: 13,
    tab: 9,
    left: 37,
    right: 39
  },
  modal: undefined,
  selectedChildren(traverseObj, selectedIds) {
    return traverseObj.nodes().filter(opt => typeof opt === 'object' && !Array.isArray(opt) && !opt.hasOwnProperty('children')).map(function (x) {
      if (selectedIds.indexOf(x.value) > -1) {
        return true;
      } else {
        return false;
      }
    });
  },
  getDefaultProps() {
    return {
      style: {}
    };
  },
  componentWillMount() {
    // REFACTOR : move to "INIT" reducer
    let regex = new RegExp();
    this.cachedSelectedValues = this.props.value.map(opt => opt.value);
    let offset = this.props.options.initialHoveredOffset();
    let hoveredIndex = this.props.multiple ? 0 : this.props.options.hoveredIndex + offset;
    let payload = {
      regex,
      hoveredIndex,
      hoveredOffset: offset
    };
    return this.props.store.dispatch({
      type: 'SET_SHOW_SEARCH',
      payload
    });
  },
  componentWillUnmount() {
    if (this.modal) {
      restrictScroll.delete(this.modal);
    }
    this.props.element.classList.remove('is-active');
  },
  componentDidMount() {
    this.modal = document.getElementById('selectro-modal');
    if (this.modal) {
      restrictScroll.add(this.modal);
    }

    // debugger
    // console.log('MOUNT:', @props)
    // console.info('TODO: if has no selected value then up/down causes JS error')
    // console.info('TODO: maybe - refactor @clearSearch to isDirty state')
    if (this.input) {
      this.input.focus();
    }
    if (this.list) {
      this.handleScrolling(this.list);
      if (this.hoveredOpt) {
        // Scroll list to hovered element.
        if (this.hoveredOpt.offsetTop > this.list.offsetHeight / 2) {
          this.list.scrollTop = this.hoveredOpt.offsetTop - this.list.offsetHeight / 2 + this.hoveredOpt.offsetHeight;
        }
      }
    }
    this.props.element.className += ' is-active';
    return this.setListStyle();
  },
  componentDidUpdate(nextProps, nextState) {
    let input;
    this.setMinWidth();

    // Set input value to query string when ajax populates the field
    if (this.props.hoveredSetVia === 'ajax') {
      ({
        input
      } = this);
      input.value = this.props.query;
      input.setSelectionRange(0, input.value.length);
    }

    // Clear the input value when in a non-search Selectro
    if (this.clearSearch) {
      this.input.value = '';
      delete this.clearSearch;
    }
    if (this.list) {
      if (this.props.hasOwnProperty('hoveredIndex') && this.props.hoveredIndex) {
        // Scroll list to hovered element.
        if (this.props.hoveredSetVia !== 'pointer' && this.props.hoveredSetVia !== 'click') {
          if (this.props.hoveredIndex === 0) {
            this.list.scrollTop = 0;
          } else {
            if (this.hoveredOpt) {
              let offsetTop = 0;
              let elem = this.hoveredOpt;
              while (elem.parentNode !== this.list) {
                offsetTop += elem.offsetTop;
                elem = elem.parentNode;
              }
              this.list.scrollTop = offsetTop - this.list.offsetHeight * 0.3;
            }
          }
        }
      }
      this.setListStyle();
    }
  },
  handleBlur(e) {
    let {
      input
    } = this;
    requestAnimationFrame(() => input.focus());
  },
  handleChange(e) {
    // Fix for wickedly painful IE bug wherein the change event is firing when the input field is focused, even if that field is blank.
    if (this.props.regex.toString() !== new RegExp(SelectroUtilities.escapeRegExp(e.currentTarget.value)).toString()) {
      clearTimeout(this.noSearchTimer);
      clearTimeout(this.debounceTimer);
      let query = typeof e === 'undefined' ? '' : e.currentTarget.value;

      // Is determined by number of cachedOptions, otherwise search field appears/disappears when no matches are found.
      let filterSearch = SelectroUtilities.isSearchShown(this.props, this.props.cachedOptions);
      let regex = filterSearch ? new RegExp(SelectroUtilities.escapeRegExp(query), 'ig') : new RegExp(`^${SelectroUtilities.escapeRegExp(query)}`, 'i');
      let delay = (() => {
        switch (false) {
          case !(this.optionCounter < 200):
            return 0;
          case !(this.optionCounter < 500):
            return 100;
          default:
            return 250;
        }
      })();
      this.debounceTimer = setTimeout(() => {
        let hoveredIndex, offset, selectedContents, tree;
        if (query.length === 0) {
          offset = 0;
          tree = SelectroTree.create(JSON.parse(JSON.stringify(this.props.cachedOptions)), {
            selected: this.props.value,
            headersClickable: this.props.headersClickable,
            props: this.props
          });
          if (this.props.recentOptions && this.props.uuid) {
            this.recentOptionsTree = SelectroTree.getRecentOptions(this.props.cachedOptions, this.props.uuid, {
              headersClickable: this.props.headersClickable,
              recentOptionsOffset: this.props.recentOptionsOffset,
              ignoreNestedRecents: this.props.ignoreNestedRecents,
              props: this.props
            });
          }
        } else {
          offset = this.props.hoveredOffset || 0;
          // if @recentOptionsTree
          //   offset = offset + @recentOptionsTree.nodeLength
          tree = SelectroTree.create(JSON.parse(JSON.stringify(this.props.cachedOptions)), {
            regex,
            selected: this.props.value,
            headersClickable: this.props.headersClickable,
            filterSearch,
            props: this.props
          });
        }

        // if @props.recentOptions && @props.uuid
        //   @recentOptionsTree = SelectroTree.getRecentOptions(@props.cachedOptions, @props.uuid, {headersClickable: @props.headersClickable, filterSearch: false, recentOptionsOffset: @props.recentOptionsOffset, props: @props})

        if (filterSearch) {
          if (typeof this.props.headersClickable !== 'undefined') {
            if (this.props.headersClickable === true) {
              // @props.headersClickable # || @props.multiple && @props.headersClickable != false
              selectedContents = tree.curryNode().map(opt => opt.text);
              hoveredIndex = selectedContents.map(text => {
                regex.lastIndex = 0;
                return regex.test(text);
              }).indexOf(true); // + offset
            } else {
              selectedContents = tree.curryLeaf().map(opt => opt.text);
              hoveredIndex = selectedContents.map(text => {
                regex.lastIndex = 0;
                return regex.test(text);
              }).indexOf(true); // + offset
            }
          }
          hoveredIndex = hoveredIndex > -1 ? hoveredIndex + offset : offset;
        } else {
          if (this.props.hasOwnProperty('headersClickable') && this.props.headersClickable === true) {
            selectedContents = tree.curryNode().map(opt => opt.text);
            hoveredIndex = selectedContents.map(text => {
              regex.lastIndex = 0;
              return regex.test(text);
            }).indexOf(true);
          } else {
            selectedContents = tree.curryLeaf().map(opt => opt.text);
            hoveredIndex = selectedContents.map(text => {
              regex.lastIndex = 0;
              return regex.test(text);
            }).indexOf(true);
          }
          if (hoveredIndex !== -1) {
            hoveredIndex = hoveredIndex + offset;
          }
        }

        // If there is no matching element, then don't change the hoveredIndex.
        if (hoveredIndex === -1) {
          hoveredIndex = undefined;
        }
        this.props.store.dispatch({
          type: 'FILTER_OPTIONS',
          options: tree,
          regex,
          query,
          hoveredIndex
        });

        // If the search field is not shown, the replicate the default <select> behavior of typing a few letters,
        // highlighting the first option where the letters match the start of the string,
        // and then after a delay allowing a completely new bit of text to be entered and matched.
        //# TODO : DO WE STILL NEED THIS?
        if (!filterSearch) {
          return this.noSearchTimer = setTimeout(() => {
            this.clearSearch = true;
            return this.props.store.dispatch({
              type: 'RESET_QUERY'
            });
          }, 750);
        }
      }, delay, regex, query);
      return;
    }
  },
  handleClear(e) {
    this.listCleared = true; // Ensure that once the list is cleared, no previously selected options appear in the list.
    let value = [];
    let previousSelected = this.props.value;
    let tree = SelectroTree.create(JSON.parse(JSON.stringify(this.props.cachedOptions)), {
      selected: this.props.value,
      headersClickable: this.props.headersClickable,
      props: this.props
    });
    let payload = {
      value,
      regex: new RegExp(),
      hoveredIndex: 0,
      hoveredOffset: 0,
      options: tree,
      query: ''
    };
    this.props.store.dispatch({
      type: 'CLEAR_SELECTED',
      payload
    });
    this.input.value = '';

    // If selected value is the same as before, don't do anything (prevents reactive updates from being called).
    if (JSON.stringify(this.props.value) !== JSON.stringify(value)) {
      this.updateRemote([]);
      this.updateTrigger(value);
    }
    const autoUpdatePreviouslySelected = this.props.submenuAutoupdate ? this.props.submenuAutoupdate.selections ? this.props.submenuAutoupdate.selections : [] : [];
    persistAutoupdateToTrigger(autoUpdatePreviouslySelected, [], this.props);
    SelectroUtilities.callback(this.props.clearCallback, {
      currentState: this.props.store.getState(),
      previousSelected,
      autoUpdatePreviouslySelected
    });
  },
  handleClick(e) {
    return e.stopPropagation();
  },
  handleFocus(e) {
    let {
      input
    } = this;
    input.setSelectionRange(0, input.value.length);
    // if @props.fetch && (!@props.hasOwnProperty('options') || @props.options.children.length == 0)
    if (this.props.fetch && this.props.cachedOptions.nodeLength === 0 && !this.props.fetching) {
      this.props.store.dispatch({
        type: 'FETCH_OPTIONS',
        payload: {
          fetching: true
        }
      });
      let {
        fetch
      } = this.props;
      if (/\?/.test(fetch)) {
        fetch += '&';
      } else {
        fetch += '?';
      }
      fetch += `authenticity_token=${document.querySelector('meta[name="csrf-token"]').content}`;
      $.ajax({
        url: fetch,
        success: obj => {
          let offset;
          if (this.props.fetchTransformCallback) {
            obj = SelectroUtilities.callback(this.props.fetchTransformCallback, obj);
          }
          let options = {
            children: obj.options || obj.children || []
          };
          if (this.props.recentOptions && this.props.uuid) {
            this.recentOptionsTree = SelectroTree.getRecentOptions(options, this.props.uuid, {
              regex: this.props.regex,
              headersClickable: this.props.headersClickable,
              recentOptionsOffset: this.props.recentOptionsOffset,
              ignoreNestedRecents: this.props.ignoreNestedRecents,
              props: this.props
            });
            offset = this.recentOptionsTree ? this.recentOptionsTree.nodeLength : 0;
          } else {
            offset = 0;
          }
          if (this.props.myWorkTree) {
            offset += 1;
          }

          // Cache options on trigger element to prevent ajax if re-opened.
          if (!this.props.nocache) {
            this.props.element.setAttribute('data-options', JSON.stringify(options));
          }
          let filterSearch = SelectroUtilities.isSearchShown(this.props);
          let tree = SelectroTree.create(options, {
            selected: this.props.value,
            headersClickable: this.props.headersClickable,
            offset,
            filterSearch,
            props: this.props
          });
          offset = tree.initialHoveredOffset();
          let query = this.props.multiple || this.props.collapsible ? '' : this.props.value.map(x => x.text).slice(-1)[0];
          this.props.store.dispatch({
            type: 'UPDATE_OPTIONS',
            payload: {
              options: tree,
              cachedOptions: tree,
              hoveredSetVia: 'ajax',
              query,
              // hoveredIndex: tree.hoveredIndex + offset
              hoveredIndex: this.props.multiple ? 0 : tree.hoveredIndex,
              // + offset  # CHECK
              hoveredOffset: offset,
              fetching: false
            }
          });
          return SelectroUtilities.callback(this.props.fetchCallback, this.props.store.getState());
        }
      });
    }
  },
  handleKeyDown(event) {
    let arrow, box, counter, li, lis, node;
    if (this.props.keydownCallback) {
      this.props.keydownCallback(event);
    }
    let {
      input
    } = this;
    switch (event.keyCode) {
      case this.keys.up:
        if (this.props.collapsible) {
          counter = this.props.hoveredIndex;
          lis = Array.apply(null, this.list.querySelectorAll('li')).slice(0, counter).reverse();
          for (li of Array.from(lis)) {
            box = li.getBoundingClientRect();
            if (box.width > 0 && box.height > 0) {
              this.props.store.dispatch({
                type: 'HOVER_PREVIOUS',
                counter: counter - 1,
                collapsible: true
              });
              break;
            } else {
              counter--;
            }
          }
        } else {
          this.props.store.dispatch({
            type: 'HOVER_PREVIOUS',
            counter: this.optionCounter
          });
        }
        input.setSelectionRange(input.selectionStart, input.selectionEnd);
        event.preventDefault();
        return;
      case this.keys.down:
        if (this.props.collapsible) {
          counter = this.props.hoveredIndex + 1;
          lis = Array.apply(null, this.list.querySelectorAll('li')).slice(counter);
          for (li of Array.from(lis)) {
            box = li.getBoundingClientRect();
            if (box.width > 0 && box.height > 0) {
              this.props.store.dispatch({
                type: 'HOVER_NEXT',
                counter,
                collapsible: true
              });
              break;
            } else {
              counter++;
            }
          }
        } else {
          this.props.store.dispatch({
            type: 'HOVER_NEXT',
            counter: this.optionCounter
          });
        }
        input.setSelectionRange(input.selectionStart, input.selectionEnd);
        event.preventDefault();
        return;
      case this.keys.right:
        if (input.value.length === 0) {
          event.preventDefault();
          if (this.props.collapsible) {
            node = this.hoveredOpt;
            if (node.classList.contains('selectro-list-header')) {
              arrow = node.parentNode.querySelector('.selectro-collapse-arrow');
              if (arrow.classList.contains('is-closed')) {
                return $(arrow).trigger('click');
              }
            }
          }
        }
        break;
      case this.keys.left:
        if (input.value.length === 0) {
          event.preventDefault();
          if (this.props.collapsible) {
            node = this.hoveredOpt;
            if (node.classList.contains('selectro-list-header')) {
              arrow = node.parentNode.querySelector('.selectro-collapse-arrow');
              if (arrow.classList.contains('is-open')) {
                return $(arrow).trigger('click');
              }
            }
          }
        }
        break;
      case this.keys.escape:
        this.props.close();
        event.preventDefault();
        return;
      case this.keys.enter:
        if (!this.hoveredNode || !this.hoveredOpt) {
          return;
        }
        const disabled = this.hoveredNode.meta && this.hoveredNode.meta.disabled || false;
        if (!disabled && !autoUpdateInParents(this.hoveredNode, this.props.submenuAutoupdate)) {
          input.setSelectionRange(0, input.selectionEnd);
          this.setSelected(this.hoveredNode);
        }
        event.preventDefault();
        return;
      case this.keys.tab:
        if (this.props.disableTab) {
          this.props.close();
        } else {
          if (this.hoveredOpt) {
            this.setSelected(this.hoveredNode);
          }
        }
        event.preventDefault();
        return;
      default:
        this.props.store.dispatch({
          type: 'SET_HOVERED_SET_VIA',
          hoveredSetVia: 'keypress'
        });
        return;
    }
  },
  handleMouseDown(opt, e) {
    e.stopPropagation();
    this.setSelected(opt, e);
  },
  handleMouseEnter(index, e) {
    if (this.props.hoveredIndex !== index) {
      if (this.props.hoveredSetVia !== 'keypress') {
        //  && @props.hoveredSetVia != 'click'
        this.props.store.dispatch({
          type: 'SET_HOVERED',
          hoveredIndex: index,
          hoveredSetVia: 'pointer'
        });
      } else {
        // Fixes keypress up/down triggering a handleMouseEnter event.
        this.props.store.dispatch({
          type: 'SET_HOVERED_SET_VIA',
          hoveredSetVia: 'pointer'
        });
      }
      return;
    }
  },
  handleScrolling(list) {
    if (!SelectroUtilities.isIE()) {
      let events = ['mousewheel', 'DOMMouseScroll', 'wheel'];
      return events.forEach(event => {
        return list.addEventListener(event, e => {
          if (list.scrollTop + e.deltaY < 0) {
            list.scrollTop = 0;
            e.preventDefault();
            e.stopPropagation();
          }
          if (list.scrollTop + list.offsetHeight + e.deltaY > list.scrollHeight) {
            list.scrollTop + list.scrollHeight;
            e.preventDefault();
            e.stopPropagation();
          }
        });
      }, false);
    }
  },
  // Manually set list maxHeight to fix overflow issue in IE when used with flex-box.
  setListStyle() {
    if (SelectroUtilities.isIE() && this.props.style.list) {
      let height = this.props.style.list.maxHeight + this.input.offsetHeight;
      if (this.headers) {
        height += this.headers.offsetHeight;
      }
      if (this.footers) {
        height += this.footers.offsetHeight;
      }
      let maxHeight = `calc(100vh - ${height}px)`;
      this.list.style.maxHeight = maxHeight;
      return;
    }
  },
  updateRemote(values) {
    if (this.props.update) {
      let method;
      let data = {
        authenticity_token: document.querySelector('meta[name="csrf-token"]').content
      };
      if (this.props.update_method) {
        method = this.props.update_method;
      } else {
        method = 'POST';
        data['_method'] = 'put';
      }
      data[this.props.name] = this.props.multiple ? values : values.toString();
      // TODO: what do we do if auto-update is set and only 'props.update' is defined?

      return $.ajax({
        url: this.props.update,
        method,
        data
      });
    }
  },
  updateTrigger(selected) {
    return this.props.element.selectroValue = selected.map(opt => [opt.text, opt.value]);
  },
  setOnly(o) {
    o = _.flatten([o]);
    return _.union(this.props.value, o);
  },
  unsetOnly(o) {
    return _.reject(this.props.value, opt => opt.value === o.value);
  },
  setDescendents(o, inclusive) {
    if (inclusive == null) {
      inclusive = false;
    }
    let type = inclusive ? 'Node' : 'Leaf';
    let curryMethod = `curry${type}`;
    return _.union(this.props.value, o[curryMethod]());
  },
  unsetDescendents(o, inclusive) {
    if (inclusive == null) {
      inclusive = false;
    }
    let type = inclusive ? 'Node' : 'Leaf';
    let curryMethod = `curry${type}`;
    return _.reject(this.props.value, opt => o[curryMethod]().map(x => x.value).indexOf(opt.value) > -1);
  },
  setParents(o, inclusive) {
    if (inclusive == null) {
      inclusive = false;
    }
    let opts = o.parents();
    if (inclusive) {
      opts.push(o);
    }
    return _.union(this.props.value, opts);
  },
  // unsetParents: (o, inclusive = false)->
  //   debugger
  //   _.reject(@props.value, (opt) ->
  //     o.parents().map((x)-> x.value).indexOf(value) > -1
  //   )

  setSelected(o, e) {
    let changes;
    let selectedValues = this.props.value.map(opt => opt.value);
    let isSelected = selectedValues.indexOf(o.value) > -1;
    if (this.props.multiple) {
      if (this.props.multiple.hasOwnProperty('type') && this.props.multiple.type.indexOf('tree') > -1) {
        if (this.props.multiple.hasOwnProperty('select_headers') && this.props.multiple.select_headers) {
          changes = isSelected ? this.unsetDescendents(o, true) : this.setDescendents(o, true);
        } else {
          isSelected = o.curryLeaf().every(x => {
            return selectedValues.indexOf(x.value) > -1;
          });
          changes = isSelected ? this.unsetDescendents(o, false) : this.setDescendents(o, false);
        }
      } else if (this.props.multiple.hasOwnProperty('type') && this.props.multiple.type.indexOf('independent') > -1) {
        changes = isSelected ? this.unsetOnly(o) : this.setOnly(o);
      } else {
        let isBoundChild = this.props.multiple.hasOwnProperty('type') && this.props.multiple.type.indexOf('bound-child') > -1;
        let isBoundParent = this.props.multiple.hasOwnProperty('type') && this.props.multiple.type.indexOf('bound-parent') > -1;
        if (isBoundChild && isBoundParent) {
          if (o.isGroup) {
            changes = isSelected ? this.unsetOnly(o) : this.setDescendents(o, true);
          } else {
            changes = isSelected ? this.unsetOnly(o, true) : this.setParents(o, true);
          }
        } else {
          if (isBoundChild) {
            changes = isSelected ? this.unsetDescendents(o, true) : this.setDescendents(o, true);
          }
          if (isBoundParent) {
            changes = isSelected ? this.unsetOnly(o, true) : this.setParents(o, true);
          }
        }
      }
    } else {
      // Only in single select mode can there be disabled options, this is done to give information to the user why the option
      // isn't selectable.
      if (o.meta && o.meta.disabled) {
        return;
      }
      changes = [o];
    }
    SelectroTree.create(JSON.parse(JSON.stringify(this.props.cachedOptions)), {
      selected: changes,
      firstSelected: o.value,
      headersClickable: this.props.headersClickable,
      props: this.props
    });
    let selectedList = this.list.querySelector('.selectro-selected-list');
    if (selectedList) {
      this.oldScrollOffset = selectedList.offsetHeight;
    }
    // offset = tree.selectedOffset() # CHECK

    let optElement = typeof e === 'undefined' ? this.hoveredOpt : e.currentTarget;

    // Saving previous selected for use in callback
    let previousSelected = this.props.value;
    if (!previousSelected) {
      previousSelected = [];
    }
    let payload = {
      value: changes,
      hoveredIndex: parseInt(optElement.getAttribute('data-i'), 10),
      // - @props.hoveredOffset # + offset # CHECK
      // hoveredOffset: offset # CHECK
      hoveredSetVia: 'click'
    };
    this.props.store.dispatch({
      type: 'SET_SELECTED',
      payload
    });
    if (this.props.recentOptions && this.props.uuid) {
      // By default, show 3 recently selected values. Can set to a higher number as needed through props.recentOptions.
      let recentOptions;
      let numSaved = parseInt(this.props.recentOptions, 10);
      numSaved = isNaN(numSaved) ? 3 : numSaved;
      let selectroStorage = localStorage.getItem('selectro-recent');
      if (selectroStorage) {
        recentOptions = JSON.parse(selectroStorage);
      } else {
        recentOptions = {};
      }
      let recentOptionsList = recentOptions[this.props.uuid] ? recentOptions[this.props.uuid] : [];
      recentOptionsList = _.uniq([o.value].concat(recentOptionsList)).slice(0, numSaved);
      recentOptions[this.props.uuid] = recentOptionsList;
      localStorage.setItem('selectro-recent', JSON.stringify(recentOptions));
    }

    // If selected value is the same as before, don't do anything (prevents reactive updates from being called).
    if (JSON.stringify(this.props.value) !== JSON.stringify(changes)) {
      this.updateRemote(changes.map(x => x.value));
      this.updateTrigger(changes);
    }
    SelectroUtilities.callback(this.props.selectedCallback, {
      option: o,
      currentState: this.props.store.getState(),
      previousSelected,
      action: isSelected ? 'removed' : 'added'
    });
    if (!this.props.multiple) {
      this.props.close();
    }
  },
  // Ensure that the popup window never shrinks smaller than its rendered size.
  // Still allow it to grow in order to accomodate larger width dictated by bolded matching text.
  setMinWidth() {
    let {
      popup
    } = this;
    let width = popup.offsetWidth;
    if (width > parseInt(popup.style.minWidth, 10)) {
      return popup.style.minWidth = `${width}px`;
    }
  },
  //### RENDER ######################################

  rawHTML(text) {
    return {
      __html: text
    };
  },
  autoCounter(mutate) {
    if (mutate == null) {
      mutate = true;
    }
    if (mutate) {
      return this.optionCounter++;
    } else {
      return this.optionCounter + 1;
    }
  },
  render() {
    let inputMinHeight, query, recentOptionsList, searchFieldPlaceholder, selectedList, tooManyOptions;
    let classNames = 'selectro-popup';
    classNames += this.props.style.hasOwnProperty('bottom') ? ' is-reversed' : '';
    classNames += this.props.multiple ? ' selectro-popup-multiple' : '';
    classNames += this.props.multiple && typeof this.props.headersClickable !== 'undefined' && this.props.headersClickable === false ? ' selectro-popup-multiple-headers-disabled' : '';
    classNames += this.props.modalClassName ? ` ${this.props.modalClassName}` : '';
    classNames += this.props.fetch && !this.props.element.getAttribute('data-options') ? ' selectro-is-loading' : '';
    let inputClassNames = 'selectro-input';

    // Is determined by number of cachedOptions, otherwise search field appears/disappears when no matches are found.
    let searchFieldVisible = SelectroUtilities.isSearchShown(this.props, this.props.cachedOptions);
    inputClassNames += searchFieldVisible ? ' has-search' : ' no-search';
    let content = this.props.value.map(x => x.text);
    let wrappers = {};
    let handleClose = () => {
      return requestAnimationFrame(() => {
        this.props.close();
      });
    };
    ['headers', 'footers'].forEach((name, i) => {
      const singularName = name.replace(/s$/, '');
      const items = [];
      if (this.props[name] && this.props[name].length > 0) {
        this.props[name].forEach(opt => {
          items.push(/*#__PURE__*/React.createElement("div", {
            key: `item-${i}`,
            className: `selectro-${singularName}`,
            dangerouslySetInnerHTML: this.rawHTML(opt),
            onClick: handleClose
          }));
        });
      }
      const reactPropName = `${name}React`;
      const reactItems = this.props[reactPropName];
      if (reactItems && reactItems.length > 0) {
        reactItems.forEach(item => {
          items.push(/*#__PURE__*/React.createElement("div", {
            key: `react-item-${i}`,
            className: `selectro-${singularName}`,
            onClick: handleClose
          }, item));
        });
      }
      if (items.length) {
        wrappers[name] = /*#__PURE__*/React.createElement("div", {
          ref: ref => this[name] = ref,
          className: `selectro-${name}`
        }, items);
      }
    });
    if (searchFieldVisible) {
      searchFieldPlaceholder = '';
    } else {
      searchFieldPlaceholder = /*#__PURE__*/React.createElement("div", {
        className: "selectro-input selectro-placeholder"
      }, content.join(', '));
    }
    if (this.props.multiple || this.props.collapsible && this.props.regex.toString().indexOf('/(?:)/') === 0) {
      query = '';
    } else {
      query = this.props.hasOwnProperty('query') ? this.props.query : content;
    }
    this.optionCounter = 0;

    // Show recent options tree
    if ((this.recentOptionsTree || this.props.recentOptionsTree) && this.props.cachedOptions.nodeLength > 10 && this.props.options.nodeLength > 0 && query.length === 0) {
      let tree = this.recentOptionsTree || this.props.recentOptionsTree;
      recentOptionsList = tree.react.bind(this, {
        key: 'recent',
        hideUnselected: false,
        className: 'selectro-recent-list',
        listType: 'recent',
        label: this.props.recentLabel || 'Recent'
      })();
    }
    let myWorkLink;

    // Adds a My Work link
    if (this.props.options.nodeLength && this.props.myWorkTree && query.length === 0) {
      myWorkLink = this.props.myWorkTree.react.bind(this, {
        key: 'my-work',
        hideUnselected: false,
        className: 'selectro-my-work-list',
        listType: 'my-work',
        label: 'My work'
      })();
    }
    if (this.props.multiple && this.props.options.nodeLength > 0 && this.props.value.length > 0) {
      // Displaying unfiltered options list, as we care about the *selected* options here.
      selectedList = this.props.cachedOptions.react.bind(this, {
        key: 'selected',
        hideUnselected: true,
        className: 'selectro-selected-list',
        listType: 'selected'
      })();
    } else {
      selectedList = '';
    }
    if (this.props.style.input && this.props.style.input.height) {
      inputMinHeight = {
        flexBasis: this.props.style.input.height,
        WebkitFlexBasis: this.props.style.input.height,
        msFlexBasis: this.props.style.input.height,
        MozFlexBasis: this.props.style.input.height
      };
    }
    if (this.props.options.nodeLength >= SelectroUtilities.maxNodes) {
      tooManyOptions = /*#__PURE__*/React.createElement("div", {
        key: "too-many",
        className: "selectro-too-many-results"
      }, "Too many results, search to display more \u2026");
    }
    return /*#__PURE__*/React.createElement('div', {
      className: classNames,
      ref: popup => this.popup = popup,
      style: this.props.style,
      onClick(e) {
        // this was killing turbolinks within selectros
        // return e.stopPropagation();
      }
    }, /*#__PURE__*/React.createElement("input", {
      defaultValue: query,
      className: inputClassNames,
      type: "text",
      ref: input => this.input = input,
      onBlur: this.handleBlur,
      onFocus: this.handleFocus,
      onClick: this.handleClick,
      onKeyDown: this.handleKeyDown,
      onChange: this.handleChange,
      spellCheck: "false",
      style: inputMinHeight,
      placeholder: this.props.placeholder
    }), /*#__PURE__*/React.createElement("input", {
      value: query,
      type: "hidden"
    }), searchFieldPlaceholder, /*#__PURE__*/React.createElement("div", {
      className: "selectro-dropdown"
    }, wrappers.headers, /*#__PURE__*/React.createElement("div", {
      ref: list => this.list = list,
      className: "selectro-list",
      style: this.props.listStyle,
      "data-label": this.props.label
    }, myWorkLink, recentOptionsList, selectedList, this.props.options.react.bind(this)(), tooManyOptions), wrappers.footers));
  }
});

//   # Need to set regex.lastIndex to 0 to force the regex to begin searching at position 0 for the next iteration,
//   # otherwise the second matching option will be skipped.
//   # https://www.reddit.com/r/programming/comments/apurt/strange_behavior_of_the_global_regex_flag/
//   # http://stackoverflow.com/questions/4178970/strange-regexp-related-javascript-problem-regexp-global-modifier-problem-in-fir
//   # http://stackoverflow.com/questions/1520800/why-regexp-with-global-flag-in-javascript-give-wrong-results
//   regex.lastIndex = 0

let convertOptionArrayToHash = function (opt) {
  let value;
  let text = opt[0];
  if (opt.length === 1) {
    value = text;
  } else {
    value = opt[1];
  }
  value = value === null ? '' : value.toString();
  let option = {
    text,
    value
  };
  if (opt.length > 2) {
    Object.keys(opt[2]).forEach(key => option[key] = opt[2][key]);
  }
  return option;
};
let coerceFlatHashToStructure = function (x) {
  let options = {
    children: []
  };
  for (let key in x) {
    if (key === '') {
      // Handle instance where there is effectively no group.
      x[key].forEach(function (opt) {
        let text = opt[0];
        let value = opt.slice(-1)[0];
        value = value === null ? '' : value.toString();
        return options.children.push({
          text,
          value
        });
      });
    } else {
      let children = x[key].map(function (opt) {
        let text = opt[0];
        let value = opt.slice(-1)[0];
        value = value === null ? '' : value.toString();
        return {
          text,
          value
        };
      });
      options.children.push({
        text: key,
        value: key,
        children
      });
    }
  }
  return options;
};
let coerceToStructure = function (x) {
  if (Array.isArray(x)) {
    return {
      children: x.map(opt => convertOptionArrayToHash(opt))
    };
  } else {
    if (!x.hasOwnProperty('children')) {
      return coerceFlatHashToStructure(x);
    } else {
      if (!Array.isArray(x.children)) {
        let children;
        let processedChildren = [];
        for (let key of Array.from(Object.keys(x.children))) {
          if (key === '') {
            let child = x.children[key];
            child.forEach(function (opt) {
              let text = opt[0];
              let value = opt.slice(-1)[0];
              value = value === null ? '' : value.toString();
              return processedChildren.push({
                text,
                value
              });
            });
          } else {
            children = x.children[key].map(function (opt) {
              let text = opt[0];
              let value = opt.slice(-1)[0];
              value = value === null ? '' : value.toString();
              return {
                text,
                value
              };
            });
            processedChildren.push({
              text: key,
              children
            });
          }
        }
        x.children = processedChildren;
      }
      return x;
    }
  }
};
var Selectro$1 = createReactClass({
  displayName: "components",
  overlayClick(event) {
    // don't close for clicks inside the popup
    if (event.target.closest(".selectro-popup")) {
      return;
    }
    this.close(event);
  },
  close(event) {
    if (event && event.nativeEvent.type === 'touchstart' && !/selectro-overlay/.test(event.target.className)) {
      return;
    }
    // Use .getElementById rather than @refs, otherwise get an error when .remove() is called.
    this.props.store.dispatch({
      type: 'HIDE_SELECTRO'
    });
    let modal = document.getElementById('selectro-modal');
    if (modal) {
      var _modal$__reactRoot, _modal$parentNode;
      // if Modal exists in the dom still, remove it
      // don't unmount completely, as another selectro might grab it before it's unmounted
      (_modal$__reactRoot = modal.__reactRoot) === null || _modal$__reactRoot === void 0 ? void 0 : _modal$__reactRoot.render(null);
      (_modal$parentNode = modal.parentNode) === null || _modal$parentNode === void 0 ? void 0 : _modal$parentNode.removeChild(modal);
    }
    delete this.props.element.Selectro;
    SelectroUtilities.callback(this.props.closeCallback);
    // Get element underneath the exact x,y position that was clicked on and click it. Ensure we do this *only* if the event in question was a click.
    if (event && event.type === 'click') {
      let elemUnderneath = document.elementFromPoint(event.clientX, event.clientY);
      if (elemUnderneath && elemUnderneath.focus != null && elemUnderneath.click != null) {
        elemUnderneath.focus();
        return elemUnderneath.click();
      }
    }
  },
  componentWillMount() {
    SelectroUtilities.callback(this.props.beforeOpenCallback);

    // TODO: UGH, refactor this mess.

    // Hold a reference to this popup on the element.
    this.props.element.Selectro = this;
    this.unsubscribe = this.props.store.subscribe(() => {
      return this.forceUpdate();
    });

    // TODO : refactor ... this is ugly as heck
    let obj = {
      isFocused: false,
      style: this.setPosition()
    };
    let newObj = SelectroUtilities.merge({}, this.props);
    newObj = SelectroUtilities.merge(newObj, obj);
    newObj.selected = newObj.value.map(function (x) {
      if (x.hasOwnProperty('meta')) {
        let {
          meta
        } = x;
        delete x.meta;
        Object.keys(meta).forEach(key => x[key] = meta[key]);
      }
      return x;
    });
    let processed = this.processOptions(newObj.options);
    if (this.props.hasOwnProperty('multiple') && typeof this.props.headersClickable === 'undefined' && typeof this.props.headers_clickable === 'undefined') {
      newObj.headersClickable = true;
    } else {
      newObj.headersClickable = this.props.hasOwnProperty('headersClickable') ? this.props.headersClickable : this.props.headers_clickable;
    }
    if ((this.props.recentOptions || this.props.recent_options) && this.props.uuid) {
      let recentOptionsOffset = this.props.recentOptionsOffset || this.props.recent_options_offset;
      const ignoreNestedRecents = this.props.ignoreNestedRecents || this.props.ignore_nested_recents;
      this.recentOptionsTree = SelectroTree.getRecentOptions(processed.options, this.props.uuid, {
        headersClickable: newObj.headersClickable,
        recentOptionsOffset,
        ignoreNestedRecents,
        props: this.props
      });
    }
    if (this.props.myWorkLink) {
      this.myWorkTree = SelectroTree.create({
        children: [{
          text: 'My work',
          value: 'my-work',
          meta: {
            myWorkLink: this.props.myWorkLink,
            prepend: [{
              icon_class: 'fa-regular fa-briefcase'
            }]
          }
        }]
      }, {
        props: this.props
      });
    }
    let offset = this.recentOptionsTree ? this.recentOptionsTree.nodeLength : 0;
    if (this.myWorkTree) {
      offset += 1;
    }
    SelectroTree.create(processed.options, {
      selected: newObj.value,
      headersClickable: newObj.headersClickable,
      offset,
      props: this.props
    });
    delete newObj.options;
    newObj = SelectroUtilities.merge(newObj, processed);
    return this.props.store.dispatch({
      type: 'INIT',
      obj: newObj
    });
  },
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize);
    return this.unsubscribe();
  },
  componentDidMount() {
    return window.addEventListener('resize', this.handleResize);
  },
  handleResize() {
    return requestAnimationFrame(() => {
      this.props.store.dispatch({
        type: 'SET_POSITION',
        style: this.setPosition()
      });
    });
  },
  // TODO : cleanup!
  processOptions(options, selected, hovered) {
    let hoveredIndex = undefined;
    if (options) {
      options = typeof options === 'string' ? JSON.parse(options) : options;
      options = coerceToStructure(options);
    } else {
      options = [];
    }
    let regex = new RegExp('');
    return {
      options,
      cachedOptions: options,
      // selected: selected,
      query: this.props.value.map(x => x.text).join(', '),
      hoveredIndex,
      regex
    };
  },
  setPosition() {
    let root = document.documentElement;
    let style = {};
    let shrink = 50;
    let boundingBox = this.props.element.getBoundingClientRect();
    style.minWidth = boundingBox.width;
    let viewportWidth = '100vw';
    let viewportHeight = '100vh';
    try {
      // If we're in an iframe, use the parent's viewport width /
      // height, since ours will be wrong.
      if (window.top !== window.self) {
        viewportWidth = `${window.parent.innerWidth}px`;
        viewportHeight = `${window.parent.innerHeight}px`;
        root = window.parent.document.documentElement;
      }
    } catch (e) {
      console.error(e);
    }
    if (root.clientWidth / 2 > boundingBox.left + boundingBox.width / 2) {
      style.left = boundingBox.left;
      style.maxWidth = `calc(${viewportWidth} - ${boundingBox.left + shrink * 1.5}px)`;
    } else {
      style.right = root.clientWidth - boundingBox.right;
      style.maxWidth = `calc(${viewportWidth} - ${root.clientWidth - boundingBox.right + shrink * 1.5}px)`;
    }
    if (root.clientHeight / 2 > boundingBox.top + boundingBox.height / 2) {
      style.top = boundingBox.top;
      style.maxHeight = `calc(${viewportHeight} - ${boundingBox.top + shrink}px)`;

      // IE does not handle flex-shrink correctly for .selectro-list, causes options to overrun container.
      // Manually set the maxHeight for the list to prevent this. A bit fragile, because we depend upon
      // knowing the height of the input field ahead of render time (26 value below).
      if (SelectroUtilities.isIE()) {
        style.list = {};
        style.list.maxHeight = boundingBox.top + shrink;
      }
    } else {
      style.bottom = root.clientHeight - boundingBox.bottom;
      style.maxHeight = `calc(${viewportHeight} - ${root.clientHeight - boundingBox.bottom + shrink}px)`;

      // IE does not handle flex-shrink correctly for .selectro-list, causes options to overrun container.
      // Manually set the maxHeight for the list to prevent this. A bit fragile, because we depend upon
      // knowing the height of the input field ahead of render time (26 value below).
      if (SelectroUtilities.isIE()) {
        style.list = {};
        style.list.maxHeight = root.clientHeight - boundingBox.bottom + shrink;
      }
    }

    // Allow the input field to grow in height if the trigger is taller than 24px.
    if (boundingBox.height > 24) {
      let computedStyle = window.getComputedStyle(this.props.element);
      style.input = {};
      style.input.height = boundingBox.height - parseInt(computedStyle.borderTopWidth, 10) - parseInt(computedStyle.borderBottomWidth, 10);
    }
    return style;
  },
  render() {
    let state = this.props.store.getState();
    let showSearch = parseInt(this.props.showSearch || this.props.show_search, 10);
    return /*#__PURE__*/React.createElement("div", {
      className: "selectro-overlay",
      ref: overlay => this.overlay = overlay,
      onClick: this.overlayClick,
      onTouchStart: this.overlayClick
    }, /*#__PURE__*/React.createElement(SelectroPopup, {
      store: this.props.store,
      options: state.options,
      cachedOptions: state.cachedOptions,
      value: state.value,
      style: state.style,
      regex: state.regex,
      hoveredIndex: state.hoveredIndex,
      hoveredOffset: state.hoveredOffset,
      hoveredSetVia: state.hoveredSetVia,
      showSearch: isNaN(showSearch) ? this.props.showSearch : showSearch,
      myWorkTree: this.myWorkTree,
      searchExcludeChildren: state.searchExcludeChildren,
      query: state.query,
      element: this.props.element,
      fetch: this.props.fetch,
      nocache: this.props.nocache,
      fetching: state.fetching,
      update: this.props.update,
      name: this.props.name,
      modalClassName: this.props.modalClassName,
      index: this.props.index,
      selectedCallback: this.props.selectedCallback,
      clearCallback: this.props.clearCallback,
      close: this.close,
      closeCallback: this.props.closeCallback,
      processOptions: this.processOptions,
      fetchCallback: this.props.fetchCallback,
      fetchTransformCallback: this.props.fetchTransformCallback,
      headers: this.props.headers,
      headersReact: this.props.headersReact,
      footers: this.props.footers,
      footersReact: this.props.footersReact,
      multiple: this.props.multiple,
      selectingForcesDescendants: this.props.selectingForcesDescendants,
      headersClickable: state.headersClickable,
      label: this.props.label,
      collapsible: this.props.collapsible,
      placeholder: this.props.placeholder,
      recentOptions: this.props.recentOptions,
      recentLabel: this.props.recentLabel,
      recentOptionsOffset: this.props.recentOptionsOffset,
      ignoreNestedRecents: this.props.ignoreNestedRecents,
      uuid: this.props.uuid,
      recentOptionsTree: this.recentOptionsTree,
      listStyle: this.props.listStyle,
      disableTab: this.props.disableTab,
      keydownCallback: this.props.keydownCallback,
      submenuChildren: this.props.submenuChildren,
      submenuAutoupdate: this.props.submenuAutoupdate
    }));
  }
});

let canCloseModal = function (e) {
  let $target = $(e.target);
  if (!$target.parents().is(".popover") && !$target.parents().is(".aha-tooltip") && !$target.parents().is(".selectro-modal") && !$target.parents().is(".skip-popover-click") && !$target.parents().is(".react-in-place__tags__menu") && !$target.hasClass("day") && $target.parents(".datepicker").length === 0) {
    return true;
  }
};
let selectroReducers = (state, action) => {
  // console.log('ACTION:', action.type)
  let counter, openOptions;
  if (state == null) {
    state = {};
  }
  switch (action.type) {
    case "INIT":
      return SelectroUtilities.merge(state, action.obj);
    case "FETCH_OPTIONS":
      return SelectroUtilities.merge(state, action.payload);
    case "UPDATE_OPTIONS":
      return SelectroUtilities.merge(state, action.payload);
    case "HIDE_SELECTRO":
      return SelectroUtilities.merge(state, {
        isFocused: true,
        query: "",
        options: state.options
      });
    case "UPDATE_QUERY":
      return SelectroUtilities.merge(state, {
        query: action.query,
        regex: action.regex
      });
    // when 'MATCH_OPTIONS'
    //   return SelectroUtilities.merge(state, {options: action.options, hoveredIndex: action.hoveredIndex, hoveredSetVia: action.hoveredSetVia})
    case "HOVER_PREVIOUS":
      if (state.hoveredIndex === 0) {
        return state;
      } else {
        if (action.collapsible) {
          return SelectroUtilities.merge(state, {
            hoveredIndex: action.counter,
            hoveredSetVia: "keypress"
          });
        } else {
          return SelectroUtilities.merge(state, {
            hoveredIndex: state.hoveredIndex - 1,
            hoveredSetVia: "keypress"
          });
        }
      }
    case "HOVER_NEXT":
      if (action.collapsible) {
        ({
          counter
        } = action);
        return SelectroUtilities.merge(state, {
          hoveredIndex: counter,
          hoveredSetVia: "keypress"
        });
      } else if (state.hoveredIndex === action.counter - 1) {
        return state;
      } else {
        counter = state.hoveredIndex + 1;
        return SelectroUtilities.merge(state, {
          hoveredIndex: counter,
          hoveredSetVia: "keypress"
        });
      }
    case "SET_HOVERED":
      return SelectroUtilities.merge(state, {
        hoveredIndex: action.hoveredIndex,
        hoveredSetVia: action.hoveredSetVia
      });
    case "SET_HOVERED_SET_VIA":
      return SelectroUtilities.merge(state, {
        hoveredSetVia: action.hoveredSetVia
      });
    case "SET_SELECTED":
      // FIXME : Not sure why we have to first delete the state.value and state.content values when we are removing selected values, but we do :(
      // Probably related to how the "merge" function is working.
      delete state.value;
      return SelectroUtilities.merge(state, action.payload);
    // when 'SET_SELECTED_GROUP'
    //   # FIXME : Not sure why we have to first delete the state.value and state.content values when we are removing selected values, but we do :(
    //   # Probably related to how the "merge" function is working.
    //   # delete state.selectedGroups
    //   # delete state.contentGroups
    //   delete state.selected
    //   delete state.content
    //   # debugger
    //   return SelectroUtilities.merge(state, {selected: action.value, content: action.content, query: action.placeholder, hoveredIndex: action.hoveredIndex, options: action.options})
    case "SET_SHOW_SEARCH":
      if (!action.payload.hoveredIndex) {
        action.payload.hoveredIndex = 0;
      }
      return SelectroUtilities.merge(state, action.payload);
    case "FILTER_OPTIONS":
      // Have to delete existing options, otherwise the merge causes options that have been filtered out to reappear in the options list.
      delete state.options;
      return SelectroUtilities.merge(state, {
        options: action.options,
        regex: action.regex,
        query: action.query,
        hoveredIndex: action.hoveredIndex,
        hoveredSetVia: "keypress"
      });
    case "RESET_QUERY":
      return SelectroUtilities.merge(state, {
        query: "",
        regex: new RegExp("")
      });
    case "CLEAR_SELECTED":
      state.value = [];
      if (state.submenuAutoupdate) {
        state.submenuAutoupdate.selections = [];
      }
      // action.payload.query = ''
      // action.regex = new RegExp('')
      return SelectroUtilities.merge(state, action.payload);
    case "SET_POSITION":
      // Prevent pre-existing style from being merged with new style (should be a complete overwrite, so as to prevent errant top:bottom or right:left issues)
      state = SelectroUtilities.merge({}, state);
      delete state.style;
      return SelectroUtilities.merge(state, {
        style: action.style
      });
    case "TOGGLE_ARROW":
      delete state.collapseState;

      // Set a sessionStorage variable to maintain the collapsed state.
      if (action.uuid) {
        let selectroStorage = sessionStorage.getItem("selectro-collapsible");
        if (selectroStorage) {
          openOptions = JSON.parse(selectroStorage);
        } else {
          openOptions = {};
        }
        openOptions[action.uuid] = action.payload;
        sessionStorage.setItem("selectro-collapsible", JSON.stringify(openOptions));
      }
      if (!openOptions) {
        openOptions = action.payload;
      }
      return SelectroUtilities.merge(state, {
        collapseState: openOptions
      });
    case "SET_AUTOUPDATE":
      state.value = action.selectedOptions;
      state.submenuAutoupdate.selections = action.autoUpdateSelected;
      return SelectroUtilities.merge({}, state);
    default:
      return state;
  }
};
let camelizeProps = props => {
  return _.mapKeys(props, (value, key) => _.camelCase(key));
};
var SelectroHelper = {
  activate(event, props) {
    if (props == null) {
      props = {};
    }
    event.preventDefault();
    event.stopPropagation();
    let elem = event.currentTarget || event.target;
    let modal = document.getElementById("selectro-modal");
    if (!modal) {
      var _modal$showPopover, _modal;
      let body = document.querySelector("body");
      let node = document.createElement("div");
      node.setAttribute("id", "selectro-modal");
      node.setAttribute("class", "selectro-modal");
      body.appendChild(node);
      modal = document.getElementById("selectro-modal");
      modal.__reactRoot = client.createRoot(modal);
      modal.popover = "manual";
      // we don't support browsers that don't support popover, but it'll mostly work for them anyway
      (_modal$showPopover = (_modal = modal).showPopover) === null || _modal$showPopover === void 0 ? void 0 : _modal$showPopover.call(_modal);
    }
    props = camelizeProps(props);
    Array.prototype.slice.call(elem.attributes).forEach(function (attr) {
      let name;
      if (/^data-/.test(attr.name)) {
        name = attr.name.replace(/^data-/, "");
      } else {
        ({
          name
        } = attr);
      }
      if (name === "content") {
        if (attr.nodeValue === "") {
          return props[name] = {};
        } else {
          return props[name] = JSON.parse(attr.nodeValue);
        }
      } else if (name === "selectrovalue") {
        return props.value = JSON.parse(attr.nodeValue);
      } else {
        if (name !== "value") {
          let value = (() => {
            try {
              let temp = JSON.parse(attr.nodeValue);
              try {
                return JSON.parse(temp);
              } catch (error) {
                return temp;
              }
            } catch (error1) {
              return attr.nodeValue;
            }
          })();
          props[_.camelCase(name)] = value;
          return props[name] = value;
        }
      }
    });
    props.element = elem;
    props.beforeOpenCallback = function () {
      if (canCloseModal(event)) {
        return $("html").click();
      }
    };
    elem.focus();
    if (props.nil) {
      elem.setAttribute("data-nil", props.nil);
    }
    if (props.value) {
      // Ensure element's data-selectrovalue is always set so we know it's
      // there when we redefine how HTMLButtonElement work https://github.com/aha-app/selectro/blob/29eea593c21f94e760b56252637c7a4331c9f137/lib/assets/javascripts/selectro-helper.coffee#L207
      // It would not be there by default if we set it via props instead of data attributes
      elem.setAttribute("data-selectrovalue", JSON.stringify(props.value));
      props.value = props.value.map(function (opt) {
        let value;
        let text = opt[0] === null ? "" : opt[0].toString();
        if (opt.length === 1) {
          value = text;
          return {
            text,
            value: text
          };
        } else {
          value = opt[1] === null ? "" : opt[1].toString();
          let option = {
            text,
            value
          };
          if (opt.length === 3) {
            option.meta = opt[2];
          }
          return option;
        }
      });
    } else {
      props.value = [];
    }
    if (!props.hasOwnProperty("options")) {
      props.options = [];
    }
    props.store = redux.createStore(selectroReducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());
    return modal.__reactRoot.render(/*#__PURE__*/React.createElement(Selectro, props));
  },
  // Pre-fetch options from the API, and store those options on the trigger so they do not need to
  // be loaded the first time the user clicks the control.
  preFetch(event) {
    let elem = event.currentTarget;
    let fetch = elem.getAttribute("data-fetch");
    let options = elem.getAttribute("data-options");
    if (/\?/.test(fetch)) {
      fetch += "&";
    } else {
      fetch += "?";
    }
    fetch += `authenticity_token=${document.querySelector('meta[name="csrf-token"]').content}`;
    return $.ajax({
      url: fetch,
      success(obj) {
        options = {
          children: obj.options
        };
        return elem.setAttribute("data-options", JSON.stringify(options));
      }
    });
  },
  selectroReducers
};

// Redefine how the "value" attribute is accessed on a button with a class of "selectro-trigger".
// Shouldn't be much of a performance hit (for non-selectro buttons) because button values are almost never set or read anyway.
Object.defineProperty(HTMLButtonElement.prototype, "selectroValue", {
  configurable: true,
  get() {
    if (this.className.split(" ").indexOf("selectro-trigger") === -1) {
      return this.getAttribute("value");
    } else {
      let values = JSON.parse(this.getAttribute("data-selectrovalue")).map(opt => opt[1]);
      if (this.getAttribute("data-multiple")) {
        return JSON.stringify(values);
      } else {
        return values[0];
      }
    }
  },
  set(value) {
    let $trigger = $(this);

    // Add additional value hooks like:
    //   * valuePrevious (value before set takes place)
    //   * valueAdded (options that were added to the previous value)
    //   * valueRemoved (options that were removed from the previous value)
    //   * valueDelta (the total change set, both added and subtracted -- useful in "toggle" type operations)

    let setAdditionalValues = function (opts) {
      this.valuePrevious = typeof this.getAttribute("data-selectrovalue") === "undefined" ? [] : JSON.parse(this.getAttribute("data-selectrovalue"));
      let optsFrozen = opts.map(opt => JSON.stringify(opt));
      let valuePreviousFrozen = this.valuePrevious.map(opt => JSON.stringify(opt));
      let added = _.difference(optsFrozen, valuePreviousFrozen);
      let removed = _.difference(valuePreviousFrozen, optsFrozen);
      this.valueAdded = added.map(opt => JSON.parse(opt));
      this.valueRemoved = removed.map(opt => JSON.parse(opt));
      this.valueDelta = _.union(added, removed).map(opt => JSON.parse(opt));
    };

    // If popup is open reposition it after content is updated (as that may shift the position of the trigger on the page).
    let repositionPopup = function () {};
    //# Deactivated code
    // if this.hasOwnProperty('Selectro')
    //   this.Selectro.handleResize()

    if (typeof value === "string") {
      try {
        value = JSON.parse(value);
      } catch (error1) {
        console.error(`When setting a selectro-trigger value manually you must provide that value as a nested array. Ex. [["SelectedText", "SelectedValue"]]. ${value}`);
      }
    }
    const $contentNode = $trigger.find(".selectro-trigger-content");
    const hasCustomTriggerContent = this.getAttribute("data-has-custom-trigger-content") === "true";
    if (Array.isArray(value[0]) && value[0].length > 1) {
      let opts = value.map(function (v) {
        let t = (v[0] + "").replace(/</g, "&lt;").replace(/>/g, "&gt;");
        v = (v[1] + "").replace(/"/g, '"');
        return [t, v];
      });
      opts = _.uniqBy(opts, opt => opt[1]);
      if (!hasCustomTriggerContent) $contentNode.html("");
      let placeholder = [];
      let returnValues = [];
      opts.forEach(function (opt) {
        placeholder.push(opt[0]);
        if (!hasCustomTriggerContent) {
          $contentNode.append(`<div>${opt[0]}</div>`);
        }
        return returnValues.push(opt[1]);
      });
      let triggerName = this.getAttribute("data-name");
      if (triggerName) {
        let $inputNode = $trigger.find(".selectro-trigger-inputs");
        $inputNode.html(`<input type='hidden' name='ⓢ_selectro_text[${triggerName}]' value='${placeholder.join(", ")}' />`);
        opts.forEach(opt => $inputNode.append(`<input type='hidden' name='${triggerName}' value='${opt[1]}' />`));
      }
      const empty = value.length === 1 && [null, ""].includes(value[0][1]);
      this.classList.toggle("empty", empty);
      setAdditionalValues.call(this, opts);
      this.setAttribute("data-selectrovalue", JSON.stringify(opts));
      this.setAttribute("value", returnValues.join(","));
      repositionPopup.call(this);
      return $trigger.change();
    } else if (Array.isArray(value) && value.length === 0) {
      setAdditionalValues.call(this, value);
      this.setAttribute("data-selectrovalue", JSON.stringify([]));
      this.setAttribute("value", "");
      this.classList.add("empty");
      if (!hasCustomTriggerContent) {
        const nilContent = $trigger.attr("data-nil") ? `<div>${$trigger.attr("data-nil")}</div>` : "";
        $contentNode.html(nilContent);
      }
      $trigger.find(".selectro-trigger-inputs").empty();
      repositionPopup.call(this);
      return $trigger.change();
    } else {
      return console.error(`When setting a selectro-trigger value manually you must provide that value as a nested array. Ex. [["SelectedText", "SelectedValue"]]. ${value}`);
    }
  }
});

window.Selectro = Selectro$1;
window.SelectroHelper = SelectroHelper;
